var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{class:_vm.imgClass,style:(_vm.imgStyle),attrs:{"src":_vm.displaySrc,"alt":_vm.alt},on:{"error":_vm.onError,"load":_vm.onLoad}})
}
var staticRenderFns = []

export { render, staticRenderFns }